
import slideDown from './modules/slideDown';
import { modal } from './modules/modal';

let setHeight = slideDown();
modal();

// **** アンカーリンクなどで使用 ****
// const scrollTop = new SmoothScroll('a[href*="#"]', {
//   speed: 600,
//   header: '#header', // 固定ヘッダーがある場合、その高さ分も込みで追従してくれる
//   easing: 'easeInOutQuart',
// });


// メニューの切り替え
let menuTrigger = document.querySelectorAll('.js-menuTrigger');
let menu = document.querySelector('.js-menu');
menuTrigger = [].slice.call(menuTrigger);
menuTrigger.forEach((item) => {
  item.addEventListener('click', (e) => {
    menu.classList.toggle('is-active');
  });
})


// 最初にスライドダウンの各要素をディフォルト高さに設定
let data = document.querySelectorAll('.js-slideDown_wrap');
data = [].slice.call(data);

function initSetHeight(){
  let data = document.querySelectorAll('.js-slideDown_wrap');
  data = [].slice.call(data);

  data.forEach((child)=>{
    setHeight(child);
  })
}

window.addEventListener('load', function(){
  initSetHeight();
  
  let dataPersonal = document.querySelectorAll('.js-tabList_data[data-type="personal"]');
  dataPersonal = [].slice.call(dataPersonal);

  dataPersonal.forEach((item)=>{
    item.style.position = 'absolute';
  })



  // タブリストの切り替え
  let tabTrigger = document.querySelectorAll('.js-tabTrigger'); // トリガーのタブ
  tabTrigger = [].slice.call(tabTrigger);

  function setInitSlideBtn(){
    // スライドダウンボタン
    let slideDownTrigger = document.querySelectorAll(".js-slideDownBtn");
    slideDownTrigger = [].slice.call(slideDownTrigger);

    slideDownTrigger.forEach((item)=>{
      item.classList.remove('is-active');
      })
  }

tabTrigger.forEach((item) => {
  item.addEventListener('click', () => {
    // タブを切り替え
      let tabs = item.parentNode.children; // タブを全部取得
      tabs = [].slice.call(tabs);
      tabs.forEach((item)=>{
        item.classList.remove('is-active'); // タブを一旦全部無効にしておく
      })
      item.classList.add('is-active'); // 押されたタブだけ有効にする

      // 内容を切り替え
      let type = item.dataset.type; // タブのdata-typeを取得
      let content = item.parentNode.nextElementSibling.querySelectorAll('[data-type]'); // 内容を取得
      content = [].slice.call(content);
      let old = content.find((item)=>{ return item.classList.contains('is-active'); }) // 現在有効の内容
      let current = content.find((item)=>{ return type === item.dataset.type }); // これから有効の内容
      if(old === current) { // 同じ要素であれば、何もしない
        return;
      }
      old.classList.remove('is-active'); // 現在有効の内容を無効に
      old.style.position = 'absolute';
      current.classList.add('is-active'); // これから有効の内容を有効に
      current.style.position = 'relative';
      setHeight(current.querySelector('.js-slideDown_wrap'));
      setInitSlideBtn();
  }, true);
})

window.addEventListener('resize', function(){
  let slideDownTrigger = document.querySelectorAll(".js-slideDownBtn")
  slideDownTrigger = [].slice.call(slideDownTrigger);
  
  let judge = slideDownTrigger.find((item)=>{
    return item.classList.contains('is-active');
  })
  
  if(!judge){
    initSetHeight();
    setInitSlideBtn();
  }else {
    function slideDown(element){
      element.style.height = `${element.scrollHeight + 1}px`; 
      setTimeout(() => {
        element.style.height = "auto";
      }, 0);
    }
    slideDown(document.querySelector('.js-slideDown_wrap.is-active'));
  }
});


})